import ScrollManager from '../utils/scroll-manager';

export default function initAsideFilters() {
    const asideFilters = document.querySelectorAll('.js-aside-filters');
    
    asideFilters.forEach((container: Element) => {
        new AsideFilters(container);
    });
}

class AsideFilters {
    private $el: Element;
    
    constructor($el: Element) {
        this.$el = $el;
        
        this.initAsideFilters();
    }
    
    /**
    * Initialise le formulaire des filtres
    *
    * @return {void}
    */
    private initAsideFilters(): void {
        const btnOpenFiltresMobile = document.querySelector('.js-btn-filters-mobile-aside');
        const btnCloseFiltresMobile = this.$el.querySelector('.js-btn-close-filters-mobile-aside');
        const btnOpenSubFiltresMobile = this.$el.querySelectorAll('.js-aside-filters-parent');
        const btnCloseSubFiltresMobile = this.$el.querySelectorAll('.js-aside-filters-back');

        // Bouton pour ouvrir le menu filtres en mobile
        if (btnOpenFiltresMobile) {
            btnOpenFiltresMobile.addEventListener('click', () => {
                if (this.$el instanceof HTMLElement) {
                    this.$el.classList.add('open');
                }
                ScrollManager.preventScroll(true);
            });
        }
        
        // Bouton pour fermer le menu filtres en mobile
        if (btnCloseFiltresMobile) {
            btnCloseFiltresMobile.addEventListener('click', () => {
                if (this.$el instanceof HTMLElement) {
                    this.$el.classList.remove('open');
                }
                ScrollManager.preventScroll(false);
            });
        }

        btnOpenSubFiltresMobile.forEach($btn => {
            $btn.addEventListener('click', () => {
                const subFilter = $btn.nextElementSibling;
                if (subFilter) {
                    subFilter.classList.add('open');
                }
            });
        });

        btnCloseSubFiltresMobile.forEach($btn => {
            $btn.addEventListener('click', () => {
                const subFilter = $btn.parentElement;
                if (subFilter) {
                    subFilter.classList.remove('open');
                }
            });
        });
    }
}
